__webpack_require__.p = "../Areas/Partners/dist/";